import { useEffect, useRef } from "react";
import { isTaskInProgress } from "./NotificationHelpers";

const POLL_INTERVAL = 2000; // Polling interval when tasks are active: 2 seconds

/**
 * Custom hook to handle notification polling
 * ONLY polls when there are active in-progress tasks
 * No polling when modal is just open with no active tasks
 */
export const useNotificationPolling = ({
    open,
    loadNotifications,
    allNotifications,
}) => {
    const pollIntervalRef = useRef(null);

    // Check if there are any active tasks
    const hasActiveTasks = allNotifications.some(task =>
        task.type === "background_task" && isTaskInProgress(task.status)
    );

    // Polling - ONLY when there are active in-progress tasks
    useEffect(() => {
        // Clear existing polling interval
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }

        // Only poll if there are active in-progress tasks
        if (!hasActiveTasks) {
            return;
        }

        // Set up polling interval
        pollIntervalRef.current = setInterval(loadNotifications, POLL_INTERVAL);

        return () => {
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [hasActiveTasks, loadNotifications]);

    // One-time load when modal opens (to fetch existing notifications)
    useEffect(() => {
        if (open) {
            loadNotifications();
        }
    }, [open, loadNotifications]);
};